import { Orders } from '../orders/orders.interface';

export interface RecoverState {
	email?: string;
	phone?: string;
	order_id?: string;
	oToken?: string;
	pToken?: string;
	cToken?: string;
	eToken?: string;
	mfa_token?: string;
	user_token?: string;
	postVerifyAction?: string;
	orders?: Orders;
	barcode?: string;
}

export const initialState: RecoverState = {};
